import React, { FunctionComponent } from 'react'

import LogoIcon from '@/atoms/icons/factris-logo.svg'
import { useMobileMediaQuery } from '@/helpers/media-queries'

import { LanguageSelector } from '../common'
import { HeaderWrapper } from './public-layout-styles'

const PublicHeader: FunctionComponent = () => {
  const isMobile = useMobileMediaQuery()

  return (
    <HeaderWrapper>
      {isMobile ? (
        <LogoIcon height="30px" width="150px" viewBox="0 0 155 29" alt="factris-logo" />
      ) : (
        <LogoIcon height="37px" width="202px" viewBox="0 0 155 29" alt="factris-logo" />
      )}
      <LanguageSelector isPublic />
    </HeaderWrapper>
  )
}

export default PublicHeader
